import { metrics } from '@seek/metrics-js';
import { Button, Inline } from 'braid-design-system';

import { Link } from 'src/components/Router/Link';
import type { AnalyticsCurrentPageSectionState } from 'src/modules/analytics/types';
import type { Mode, Card } from 'src/types';

interface Props {
  actionText: string;
  card: Card;
  mode: Mode;
  analytics?: {
    currentPageSectionState: AnalyticsCurrentPageSectionState;
  };
  data: Record<string, string>;
  isEmpty?: boolean;
  onClick?: () => void;
}

export const CardAction = ({
  actionText,
  card,
  mode,
  analytics,
  isEmpty,
  onClick: onClickFn = () => {},
  ...restProps
}: Props) => (
  <Inline space="none">
    <Link
      {...restProps}
      card={card}
      onClick={() => {
        onClickFn();
        if (isEmpty) {
          metrics.count('click-empty-card-add-btn', [`card:${card}`]);
        }
      }}
      mode={mode}
      component={Button}
      tone="formAccent"
      variant="ghost"
    >
      {actionText}
    </Link>
  </Inline>
);
